var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.block.data.url,"alt":_vm.block.data.name}})}
var staticRenderFns = []

export { render, staticRenderFns }